var map = {
	"./1.jpg": "3825",
	"./2.jpg": "1fcf",
	"./3.jpg": "5efc",
	"./4.jpg": "d084",
	"./5.jpg": "4411",
	"./bg.jpg": "94cc",
	"./gym.jpg": "a299"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dda1";